import { forwardRef } from 'react';
import type { HTMLAttributes } from 'react';

export const ScrollableBox = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
    ({ style, ...props }, ref) => (
        <div
            ref={ref}
            style={{
                overflowY: 'auto',
                overflowX: 'hidden',
                maxHeight: '270px',
                // Small inset so focus rings on child controls are not
                // clipped by `overflow: hidden`.
                padding: 'var(--swan-sem-space-1)',
                ...style,
            }}
            {...props}
        />
    )
);
